import { Link } from 'react-router-dom';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { categories, manhwaList, faqs } from '@/mocks/manhwa';

const formSubmitAddr = 'https://readdy.ai/api/form/d9pdk9osenbniolestd0';

export default function Home() {
  const hotManhwa = [...manhwaList].sort((a, b) => b.views - a.views).slice(0, 8);
  const latestManhwa = [...manhwaList].sort((a, b) => new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()).slice(0, 6);
  const topRated = [...manhwaList].sort((a, b) => b.rating - a.rating).slice(0, 4);

  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebPage" data={{
        name: '韩漫漫画网 - 免费韩国漫画_韩漫大全_无删减下拉式韩漫',
        description: '韩漫漫画网提供免费韩国漫画，韩漫大全无删减下拉式内容，完整呈现原版故事，画质优良，让您享受纯正阅读体验。',
        url: 'https://bluefocugroup.cn',
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      }} />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20manga%20illustration%20background%2C%20Korean%20manhwa%20style%2C%20abstract%20composition%20with%20warm%20coral%20and%20deep%20charcoal%20tones%2C%20dynamic%20brush%20strokes%2C%20atmospheric%20lighting%20with%20golden%20accents%2C%20ethereal%20floating%20particles%2C%20cinematic%20feel%2C%20rich%20texture%2C%20mysterious%20and%20inviting%20mood%2C%20no%20text&width=1600&height=900&seq=hero-bg-hanman&orientation=landscape"
            alt="韩漫漫画网 - 免费韩国漫画阅读平台"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
              韩漫漫画网
            </h1>
            <p className="text-base md:text-lg text-white/80 mb-3 max-w-2xl mx-auto leading-relaxed">
              免费韩国漫画在线阅读平台，韩漫大全无删减下拉式内容
            </p>
            <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto">
              完整呈现原版故事，画质优良，让您享受纯正阅读体验
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to={`/category/${categories[0].slug}`}
                className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                开始阅读
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">漫画分类</h2>
              <p className="text-foreground-500 text-sm max-w-lg mx-auto">探索不同类型的韩国漫画，找到你最喜欢的故事</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
                >
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200 mb-3">
                    <i className={`${cat.icon} text-xl`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">{cat.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Top Rated Section */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">高分推荐</h2>
                <p className="text-foreground-500 text-sm">评分最高的精选韩漫</p>
              </div>
              <Link to={`/category/${categories[0].slug}`} className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap cursor-pointer">
                查看全部 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {topRated.map((manhwa) => (
                <Link
                  key={manhwa.id}
                  to={`/article/${manhwa.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
                >
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={manhwa.cover}
                      alt={manhwa.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1 line-clamp-1">{manhwa.title}</h3>
                    <div className="flex items-center gap-2 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                        {manhwa.rating}
                      </span>
                      <span className="text-foreground-300">|</span>
                      <span className="bg-primary-50 text-primary-600 px-2 py-0.5 rounded-full text-xs whitespace-nowrap">{manhwa.status}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Manhwa Grid */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">热门漫画</h2>
                <p className="text-foreground-500 text-sm">最受欢迎的韩漫作品</p>
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {hotManhwa.map((manhwa) => (
                <Link
                  key={manhwa.id}
                  to={`/article/${manhwa.id}`}
                  className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
                >
                  <div className="aspect-[3/4] overflow-hidden">
                    <img
                      src={manhwa.cover}
                      alt={manhwa.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1 line-clamp-1">{manhwa.title}</h3>
                    <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{manhwa.description}</p>
                    <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-accent-500 text-xs"></i>
                        {manhwa.rating}
                      </span>
                      <span className="text-foreground-300">|</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {(manhwa.views / 10000).toFixed(1)}万
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Latest Updates */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">最新更新</h2>
              <p className="text-foreground-500 text-sm">每日更新，追更不迷路</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestManhwa.map((manhwa) => (
                <Link
                  key={manhwa.id}
                  to={`/article/${manhwa.id}`}
                  className="flex gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
                >
                  <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={manhwa.cover}
                      alt={manhwa.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex flex-col justify-between min-w-0">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-950 mb-1 line-clamp-1 group-hover:text-primary-500 transition-colors">{manhwa.title}</h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{manhwa.description}</p>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-foreground-400 flex-wrap">
                      <span>{manhwa.author}</span>
                      <span className="text-foreground-300">|</span>
                      <span className="text-accent-500">{manhwa.chapters[manhwa.chapters.length - 1]?.title}</span>
                      <span className="text-foreground-300">|</span>
                      <span>{manhwa.updateTime}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-12 md:py-16 bg-primary-500">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              {[
                { value: '2000+', label: '漫画作品' },
                { value: '500万+', label: '月活跃读者' },
                { value: '50万+', label: '章节更新' },
                { value: '99.9%', label: '服务可用率' },
              ].map((stat, i) => (
                <div key={i}>
                  <div className="text-3xl md:text-4xl font-heading font-bold text-white mb-1">{stat.value}</div>
                  <div className="text-sm text-white/70">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问题</h2>
              <p className="text-foreground-500 text-sm">关于韩漫漫画网的常见疑问解答</p>
            </div>
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <details key={index} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between p-5 text-sm font-medium text-foreground-800 list-none marker:hidden">
                    <span>{faq.question}</span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">订阅更新通知</h2>
            <p className="text-foreground-500 text-sm mb-6">第一时间获取最新漫画更新通知，追更不再错过</p>
            <form
              data-readdy-form
              className="flex flex-col sm:flex-row gap-3"
              action={formSubmitAddr}
              method="POST"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const honeypot = formData.get('website_alt');
                if (honeypot && (honeypot as string).trim() !== '') return;
                try {
                  const res = await fetch(formSubmitAddr, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const text = await res.text();
                  let parsed: Record<string, unknown> = {};
                  try { parsed = JSON.parse(text); } catch { /* ignore */ }
                  if (res.ok && parsed?.code === 'OK') {
                    form.reset();
                  }
                } catch { /* ignore */ }
              }}
            >
              <input type="email" name="email" placeholder="请输入您的邮箱地址" required className="flex-1 px-4 py-3 rounded-lg border border-background-300 text-sm text-foreground-950 bg-background-50 focus:outline-none focus:border-primary-300 placeholder:text-foreground-400" />
              <input type="text" name="website_alt" autoComplete="off" tabIndex={-1} aria-hidden="true" readOnly className="contact-honeypot" />
              <button type="submit" className="px-6 py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                立即订阅
              </button>
            </form>
          </div>
        </section>
      </main>
    </>
  );
}